<template> 
  <section 
    id="ueber-uns-team" 
    class="about-team-section" 
  > 
    <div class="about-team-container"> 
 
      <div class="about-team-heading"> 
        <h1> 
          ÜBER UNS 
        </h1> 
 
        <div class="about-team-line"></div> 
 
        <p> 
          Lernen Sie die Menschen hinter TR-Hygieneprofis kennen. 
          Wählen Sie aus, über wen Sie mehr erfahren möchten. 
        </p> 
      </div> 
 
      <div class="about-team-grid"> 
 
        <!-- ================================================= 
             THOMAS SCHERMULY 
        ================================================== --> 
 
        <v-card 
          class="about-person-card" 
          elevation="0" 
        > 
 
          <div class="about-person-image-wrapper"> 
            <v-img 
              :src="AvatarTomView" 
              alt="Thomas Schermuly" 
              class="about-person-image" 
              contain
            /> 
          </div> 
 
          <v-card-item class="about-person-content"> 
 
            <v-card-title> 
              Thomas Schermuly 
            </v-card-title> 
 
            <v-card-subtitle> 
              Hygienedozent, Auditor & Fachautor 
            </v-card-subtitle> 
 
            <v-card-text> 
              Ihr Experte für Hygiene, Schulung und 
              Lebensmittelsicherheit in der Praxis. 
            </v-card-text> 
 
            <v-card-actions> 
              <v-btn 
                to="/tom" 
                class="about-person-button" 
                variant="flat" 
                block 
              > 
                <span> 
                  Mehr über Thomas Schermuly 
                </span> 
 
                <v-icon size="17"> 
                  mdi-arrow-right 
                </v-icon> 
              </v-btn> 
            </v-card-actions> 
 
          </v-card-item> 
 
        </v-card> 
 
 
        <!-- ================================================= 
             RUBEN ROHLETTER 
        ================================================== --> 
 
        <v-card 
          class="about-person-card" 
          elevation="0" 
        > 
 
          <div class="about-person-image-wrapper"> 
            <v-img 
              :src="AvatarRubView" 
              alt="Ruben Rohletter" 
              class="about-person-image" 
              contain
            /> 
          </div> 
 
          <v-card-item class="about-person-content"> 
 
            <v-card-title> 
              Ruben Rohletter 
            </v-card-title> 
 
            <v-card-subtitle> 
              Hygienedozent 
            </v-card-subtitle> 
 
            <v-card-text> 
              Praxisnahe Hygieneberatung und Schulungen 
              für sichere und verständliche Abläufe. 
            </v-card-text> 
 
            <v-card-actions> 
              <v-btn 
                to="/rub" 
                class="about-person-button" 
                variant="flat" 
                block 
              > 
                <span> 
                  Mehr über Ruben Rohletter 
                </span> 
 
                <v-icon size="17"> 
                  mdi-arrow-right 
                </v-icon> 
              </v-btn> 
            </v-card-actions> 
 
          </v-card-item> 
 
        </v-card> 
 
      </div> 
    </div> 
  </section> 
</template> 
 
 
<script setup> 
import AvatarTomView from '../assets/AvatarTom.png' 
import AvatarRubView from '../assets/AvatarRuben.png' 
</script> 
 
 
<style scoped> 
/* ============================================================ 
   ÜBER UNS – TEAM CARDS 
============================================================ */ 
 
.about-team-section { 
  width: 100%; 
  background: #ffffff; 
  padding: 58px 0 68px; 
} 
 
.about-team-container { 
  width: calc(100% - 100px); 
  max-width: 1000px; 
  margin: 0 auto; 
} 
 
.about-team-heading { 
  text-align: center; 
  margin-bottom: 38px; 
} 
 
.about-team-heading h1 { 
  margin: 0; 
  color: #111111; 
  font-size: 30px; 
  line-height: 1.2; 
  font-weight: 700; 
  letter-spacing: 0.2px; 
} 
 
.about-team-line { 
  width: 42px; 
  height: 2px; 
  margin: 12px auto 15px; 
  background: #72b82a; 
} 
 
.about-team-heading p { 
  max-width: 620px; 
  margin: 0 auto; 
  color: #111111; 
  font-size: 12px; 
  line-height: 1.7; 
} 
 
.about-team-grid { 
  width: 100%; 
  display: grid; 
  grid-template-columns: repeat(2, minmax(280px, 460px)); 
  gap: 24px; 
  align-items: start; 
  justify-content: center; 
} 
 
.about-person-card { 
  width: 100%; 
  height: auto; 
  min-height: 0; 
  overflow: hidden; 
  display: flex; 
  flex-direction: column; 
  border: 1px solid #ededed; 
  border-top: 3px solid #72b82a; 
  border-radius: 18px; 
  background: #ffffff; 
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.10); 
  transition: 
    transform 0.2s ease, 
    box-shadow 0.2s ease; 
} 
 
.about-person-card:hover { 
  transform: translateY(-4px); 
  box-shadow: 0 16px 36px rgba(0, 0, 0, 0.14); 
} 
 
.about-person-image-wrapper { 
  width: 100%; 
  height: 285px; 
  overflow: hidden; 
  background: #f3f3f0; 
  border-radius: 14px 14px 0 0; 
  display: flex; 
  align-items: center; 
  justify-content: center; 
} 
 
.about-person-image { 
  width: 100%; 
  height: 100%; 
  display: block; 
  object-fit: contain !important; 
  object-position: center center !important; 
  background: #f3f3f0; 
  transition: transform 0.35s ease; 
} 
 
.about-person-card:hover .about-person-image { 
  transform: scale(1.015); 
} 
 
.about-person-content { 
  flex: 1 1 auto; 
  display: flex; 
  flex-direction: column; 
  padding: 17px 20px 19px !important; 
} 
 
.about-person-content .v-card-title { 
  padding: 0; 
  color: #111111; 
  font-size: 19px; 
  line-height: 1.25; 
  font-weight: 700; 
} 
 
.about-person-content .v-card-subtitle { 
  padding: 5px 0 0; 
  color: #72b82a; 
  font-size: 11px; 
  line-height: 1.45; 
  font-weight: 700; 
} 
 
.about-person-content .v-card-text { 
  padding: 12px 0 0; 
  min-height: 55px; 
  color: #111111; 
  font-size: 11px; 
  line-height: 1.7; 
} 
 
.about-person-content .v-card-actions { 
  margin-top: auto; 
  padding: 14px 0 0; 
} 
 
.about-person-button { 
  min-height: 38px; 
  padding: 0 14px; 
  background: #72b82a !important; 
  color: #ffffff !important; 
  border-radius: 2px; 
  font-size: 11px; 
  font-weight: 700; 
  text-transform: none; 
  transition: 
    background 0.2s ease, 
    transform 0.2s ease; 
} 
 
.about-person-button:hover { 
  background: #63a91d !important; 
  transform: translateY(-1px); 
} 
 
.about-person-button .v-icon { 
  margin-left: 8px; 
} 
 
 
/* ============================================================ 
   MOBILE 
============================================================ */ 
 
@media (max-width: 760px) { 
  .about-team-section { 
    padding: 42px 0 50px; 
  } 
 
  .about-team-container { 
    width: calc(100% - 40px); 
  } 
 
  .about-team-heading { 
    margin-bottom: 28px; 
  } 
 
  .about-team-heading h1 { 
    font-size: 25px; 
  } 
 
  .about-team-heading p { 
    font-size: 11px; 
  } 
 
  .about-team-grid { 
    grid-template-columns: 1fr; 
    gap: 22px; 
  } 
 
  .about-person-card { 
    min-height: 0; 
  } 
 
  .about-person-image-wrapper { 
    height: 300px; 
  } 
 
  .about-person-content { 
    padding: 19px 20px 21px !important; 
  } 
 
  .about-person-content .v-card-title { 
    font-size: 19px; 
  } 
 
  .about-person-content .v-card-text { 
    min-height: auto; 
    font-size: 11px; 
  } 
} 
 
 
/* ============================================================ 
   SEHR KLEINE GERÄTE 
============================================================ */ 
 
@media (max-width: 450px) { 
  .about-team-container { 
    width: calc(100% - 30px); 
  } 
 
  .about-team-heading h1 { 
    font-size: 23px; 
  } 
 
  .about-person-card { 
    min-height: 0; 
  } 
 
  .about-person-image-wrapper { 
    height: 260px; 
  } 
 
  .about-person-button { 
    min-height: 43px; 
  } 
} 
 
 
/* ============================================================ 
   TEAM V-CARDS – RUNDER DESKTOP-LOOK 
============================================================ */ 
 
@media (min-width: 761px) { 

  .about-person-card { 
    border-radius: 18px !important; 
    overflow: hidden !important; 
    background: #ffffff; 
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.10); 
  } 
 
  .about-person-image-wrapper { 
    height: 285px !important; 
    border-radius: 14px 14px 0 0 !important; 
    overflow: hidden !important; 
    background: #f3f3f0 !important; 

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  } 
 
  .about-person-image { 
    width: 100% !important; 
    height: 100% !important; 
    object-fit: contain !important; 
    object-position: center center !important; 
    background: #f3f3f0 !important; 
  } 

}
</style>